import { DefaultButton, DetailsList, IBasePickerSuggestionsProps, IInputProps, ITag, Label, NormalPeoplePicker, PrimaryButton, SelectionMode, Stack, TagPicker } from '@fluentui/react';
import * as React from 'react';
import { IUserListItem } from '../../../../Models/Admin/IUserListItem';
import { IAttendee } from '../../../../Models/Attendees/IAttendee';
import { AttendeesList } from '../AttendeeList/AttendeesList';
import { IUserTag } from './MiniUserList';

interface IMiniUserListViewProps {
    isLoading: boolean;
    find: (filterText: string, tagList?: IUserTag[]) => PromiseLike<IUserTag[]>;
    selectionChanged: (selection: IAttendee[]) => void;
}



export const MiniUserListView: React.FunctionComponent<IMiniUserListViewProps> = (props) => {
    const [last, setLast] = React.useState<IUserTag[]>([])
    const [selectedItems, setSelectedItems] = React.useState<ITag[]>([])

    const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Navrhovaní zákazníci',
        noResultsFoundText: 'Nebylo nic nalezeno',
        resultsMaximumNumber: 5
    };

    const listContainsTagList = (tag: IUserTag, tagList?: IUserTag[]) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };

    const getTextFromItem = (item: ITag) => item.name;

    const inputProps: IInputProps = {
        onBlur: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onBlur called'),
        onFocus: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onFocus called'),
    };

    const filterSuggestedTags = async (filterText: string, tagList?: ITag[]): Promise<IUserTag[]>=>
    {
        var items = await props.find(filterText);
        setLast(items);
        return items;
    }

    const onEmptyInputFocus = (selectedItems?: any[]) => {
        return last;
    }

    return (<Stack>
        <TagPicker
            removeButtonAriaLabel="Odebrat"
            onEmptyInputFocus={onEmptyInputFocus}
            selectionAriaLabel="Vybraný zákazník"           
            onResolveSuggestions={filterSuggestedTags}
            getTextFromItem={getTextFromItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            resolveDelay={300}
            onChange={items => items && setSelectedItems(items)}
            selectedItems={selectedItems}
            itemLimit={1}            
            inputProps={{
                ...inputProps,
                id: 'picker1',
                placeholder:"Vyhledejte registrovaného uživatele"
            }}
        />
         
         <Label>Vyberte žáka(y), které chcete přihlásit:</Label>

        <AttendeesList
            allowDelete={false}
            selectionMode={SelectionMode.multiple}
            selectionChanged={props.selectionChanged}
            userId={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.id : ""}
            city={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.city : ""}
            postalCode={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.postalCode : ""}
            email={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.email : ""}
            phoneNumber={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.phoneNumber : ""}
            street={selectedItems.length === 1 ? (selectedItems[0] as IUserTag).data.street : ""}
        />
    </Stack>)
}
